export enum StorageQueryKeys {
  GUEST_SEQ = 'guestSeq',
  CAR_NUM = 'carnum',
  IS_BANNER_CLOSED = 'isBannerClosed'
}
